import {CommonResponse, BaseRequestParams, GetParamsType, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {AttributesVersionResponse, AttributesVersionsResponse} from "../models/response"
import {UpdateFileType} from "../models/request/UpdateFileType"

export const attributeVersionApi = {
    getVersions(params?: GetParamsType): Promise<CommonResponse<AttributesVersionsResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`AttributesVersion${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getVersion(params: GetSingleParamsType): Promise<CommonResponse<AttributesVersionResponse>> {
        const {id, controller} = params
        return instance.get(`AttributesVersion/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    createVersion(params: CreateAttributesVersionType): Promise<CommonResponse<AttributesVersionResponse>> {
        const {controller, ...form} = params

        const formData = createFormData(form)

        return instance.post(`AttributesVersion`, formData, {
            signal: controller?.signal,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then((res: AxiosResponse) => res.data)
    },
    changeVersion(params: ChangeAttributesVersionType): Promise<CommonResponse<AttributesVersionResponse>> {
        const {id, controller, ...form} = params

        const formData = createFormData(form)

        return instance.put(`AttributesVersion/${id}`, formData, {
            signal: controller?.signal,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then((res: AxiosResponse) => res.data)
    },
}

function createFormData(form: CreateAttributesVersionType) : FormData {
    const formData = new FormData()

    form.firmware && formData.append("firmware", form.firmware, form.firmware.name)
    formData.append("version", form.version.toString())
    formData.append("name", form.name)
    formData.append("comment", form.comment || "")
    formData.append("changelog", form.changelog || "")
    formData.append("attributes", form.attributes)
    formData.append("active", form.active.toString())
    formData.append("updateFileType", form.updateFileType?.toString() || "")

    return formData
}

export type CreateAttributesVersionType = {
    version: number
    name: string
    comment?: string | null
    changelog?: string | null
    attributes: string
    active: boolean
    updateFileType: UpdateFileType
    firmware?: File | null
} & BaseRequestParams

export type ChangeAttributesVersionType = {
    id: number
} & CreateAttributesVersionType
